import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AfdrachtsVermindering,
  BelastNormaalTarief,
  BelastVerdragsTarief,
  BokkzAlgDataService, BokkzDivDataService, BokkzDivLogic,
  Dividendbelasting,
  DividendTaxEntity, Fonds, InhoudingsVrijstelling,
  LiquidatieUitkering
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-bijzonderhedendividend',
  standalone: true,
  imports: [CommonModule, SharedUiFormControlsModule, SharedUiDetailsModule],
  templateUrl: './bijzonderheden.component.html',
  styleUrl: './bijzonderheden.component.scss',
})
export class BijzonderhedenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private divTaxEntitySubscription: Subscription | undefined;
  public divTaxEntity = {} as DividendTaxEntity;
  public aangifte = {} as Dividendbelasting;
  public aangifteDbFg = {} as FormGroup;
  public dividendFg = {} as FormGroup;
  public index = 0;
  public formStructure: any;
  public focusedElementId: string | null = null;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzDivDataService,
    public divService: BokkzDivLogic,
    private fb: FormBuilder) {
    this.aangifteDbFg = this.fb.group({
      aangifteNummer: null as unknown as string,
      verschuldigdeBelasting: null as unknown as number,
      bedragAgioInBonusaandelen: null as unknown as number,
      bedragAgioInGeld: null as unknown as number,
      standAgioVoorUitkering: null as unknown as number,
      bedragTenOnrechteVrijgesteldeInkoopAandelen: null as unknown as number,
    })
    this.dividendFg = this.fb.group({
      subfund: null as unknown as Fonds,
      bedragDividenduitkering: null as unknown as number,
      bedragOnbelastVerbodExtraterritorialeHeffing: null as unknown as number,
      liquidatieUitkering: null as unknown as LiquidatieUitkering,
      inhoudingsVrijstelling: null as unknown as InhoudingsVrijstelling,
      belastVerdragsTarief: null as unknown as BelastVerdragsTarief,
      belastNormaalTarief: null as unknown as BelastNormaalTarief,
      afdrachtsVermindering: null as unknown as AfdrachtsVermindering,
    })
  }

  ngOnInit(): void {
    this.divTaxEntitySubscription = this.dataService.dividendTaxEntity.subscribe((value)=> {
      this.divTaxEntity = value;
      this.aangifte = value.aangifte!;
      if (this.aangifte.aangifteDb) {
        this.aangifteDbFg.patchValue(this.aangifte.aangifteDb, {emitEvent: false})
      }
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)) {
        this.dividendFg.patchValue(this.aangifte.aangifteDb?.dividendSpecificaties[0], {emitEvent: false})
      }
    })
  }

  ngOnDestroy(): void {
    if (this.divTaxEntitySubscription) {
      this.divTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
      this.aangifteDbFg.updateValueAndValidity({ emitEvent: false })
      this.dividendFg.updateValueAndValidity({ emitEvent: false })
      this.divTaxEntity.aangifte = {
        ...this.aangifte,
        aangifteDb: {
          ...this.aangifte.aangifteDb,
          aangifteNummer: this.aangifteDbFg.value.aangifteNummer,
          bedragAgioInBonusaandelen: this.aangifteDbFg.value.bedragAgioInBonusaandelen,
          bedragAgioInGeld: this.aangifteDbFg.value.bedragAgioInGeld,
          standAgioVoorUitkering: this.aangifteDbFg.value.standAgioVoorUitkering,
          bedragTenOnrechteVrijgesteldeInkoopAandelen: this.aangifteDbFg.value.bedragTenOnrechteVrijgesteldeInkoopAandelen,
          dividendSpecificaties: [this.dividendFg.value],
        }
      } as Dividendbelasting;
      this.dataService.updateDividendTaxEntity(this.divTaxEntity);
      this.divService.getCalculation(this.divTaxEntity);
  }
}

